jQuery(document).ready(function ($) {

    $('.bloc_temoignages').each(function () {
        const $block = $(this)
        const $carousel = $block.find('.carousel').first()
        if (!$carousel.length) return

        const $list = $carousel.find('> .citations')
        const $citations = $list.find('> .citation')
        const $dots = $carousel.find('> .pager .dot')
        const total = $citations.length
        if (total < 2) return

        const autoplayDelay = 6
        let current = 0
        let autoplay = null
        let isAnimating = false

        const goTo = (next) => {
            if (next === current || isAnimating) return
            isAnimating = true

            $dots.removeClass('is-active').eq(next).addClass('is-active')
            $citations.removeClass('is-active').eq(next).addClass('is-active')

            gsap.to($list, {
                xPercent: -next * 100,
                duration: 0.8,
                ease: 'power3.inOut',
                onComplete: () => {
                    isAnimating = false
                }
            })

            current = next
        }

        const next = () => {
            goTo((current + 1) % total)
        }

        const startAutoplay = () => {
            stopAutoplay()
            autoplay = gsap.delayedCall(autoplayDelay, () => {
                next()
                startAutoplay()
            })
        }

        const stopAutoplay = () => {
            if (autoplay) {
                autoplay.kill()
                autoplay = null
            }
        }

        gsap.set($list, { xPercent: 0 })

        $dots.on('click', function () {
            const target = parseInt($(this).attr('data-index'), 10)
            if (isNaN(target)) return
            stopAutoplay()
            goTo(target)
            startAutoplay()
        })

        $carousel.on('mouseenter', stopAutoplay)
        $carousel.on('mouseleave', startAutoplay)

        startAutoplay()
    })
})
